// app/javascript/controllers/review_text_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shortText", "fullText"]
  
  showFull() {
    this.shortTextTarget.classList.add("hidden")
    this.fullTextTarget.classList.remove("hidden")
  }
  
  showShort() {
    this.shortTextTarget.classList.remove("hidden")
    this.fullTextTarget.classList.add("hidden")
  }
}